export default "__VITE_ASSET__308d53f5__"